import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import { FaList, FaTag } from "react-icons/fa";

const CategoryCreateChild = () => {
  let navigate = useNavigate();
  const [{ errorLogApi, placeHolderText, Category }] = useAtom(gbState);
  const [rolesOption, setRolesOption] = useState();
  const [formData, setFormData] = useState({
    category_name: "",
    category_type: null,
    createdBy: Category?._id,
  });

  useEffect(() => {
    const category_type = [{ type: "Income" }, { type: "Expense" }];
    setRolesOption(
      category_type.map((role) => ({
        value: role.type,
        label: role.type,
      }))
    );
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const handleCategoryRegistration = (e) => {
    e.preventDefault();

    if (!formData?.category_type)
      return toast.error("Please enter category type");

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/Category/add`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData },
    };
    axios(config)
      .then(function (response) {
        toast.success("Category Created Successfully.");
        navigate("/catlist");
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error.response.data));
        errorLogApi(error, "CreateCategoryChild", "/Category/add");
      });
  };

  return (
    <div className="max-w-2xl p-6 mx-auto bg-white rounded-lg shadow-lg">
      <h2 className="mb-6 text-2xl font-semibold text-gray-800">
        Add Category
      </h2>
      <form onSubmit={handleCategoryRegistration} autoComplete="off">
        <div className="space-y-4">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Category Name
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="category_name"
                type="text"
                required
                placeholder="Enter Category"
                onChange={handleChange}
                value={formData.category_name}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaTag className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Category Type
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 z-10 flex items-center pl-3 pointer-events-none">
                <FaList className="w-5 h-5 text-gray-400" />
              </div>
              <Select
                name="category_type"
                onChange={(selected) => {
                  setFormData({
                    ...formData,
                    category_type: selected.label,
                  });
                }}
                options={rolesOption}
                placeholder={placeHolderText("Select Category")}
                className="w-full"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    paddingLeft: "2.5rem",
                    border: "1px solid #e2e8f0",
                    borderRadius: "0.375rem",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #4299e1",
                    },
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-8 space-x-4">
          <button
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            onClick={() => navigate(-1)}
            type="button"
          >
            Back
          </button>
          <button
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            type="submit"
          >
            Create
          </button>
        </div>
      </form>
    </div>
  );
};

export default CategoryCreateChild;
